// material
import MaterialTable from 'material-table';

export default function BrandTable(props) {
  const { data, machinesName } = props;

  // const MyNewTitle = ({ text = 'Table Title', variant = 'h6' }) => (
  //   <Typography variant={variant} style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
  //     {`Product Table (${machinesName} from ${startDate.toShortFormat()} to  ${endDate.toShortFormat()})`}
  //   </Typography>
  // );

  const columns = [
    {
      title: 'Name',
      field: 'name',
    },
    {
      title: 'Brand Page',
      field: 'detail',
    },
  ];

  return (
    <MaterialTable
      title={'Brands: ' + machinesName}
      columns={columns}
      data={data}
      // title={<MyNewTitle variant="h6" />}
      options={{
        actionsColumnIndex: -1,
        pageSize: 5,
        search: false,
      }}
    />
  );
}
